export default __webpack_public_path__ + "static/media/cardimg.a9c86357.png";